// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.components-CompanyDetails-CommercialRewards-styles___paper--MQNv6 {
  padding: 32px;
  max-width: 736px;
  margin: 0 0 30px;
}

  .components-CompanyDetails-CommercialRewards-styles___paper--MQNv6 .components-CompanyDetails-CommercialRewards-styles___commercialRewardsHeader--XN_Sh {
    display: flex;
  }

  .components-CompanyDetails-CommercialRewards-styles___paper--MQNv6 .components-CompanyDetails-CommercialRewards-styles___commercialRewardsHeader--XN_Sh .components-CompanyDetails-CommercialRewards-styles___text--AK1QF {
      margin-left: 22px;
    }

  .components-CompanyDetails-CommercialRewards-styles___paper--MQNv6 .components-CompanyDetails-CommercialRewards-styles___commercialRewardsHeader--XN_Sh .components-CompanyDetails-CommercialRewards-styles___text--AK1QF h2 {
        font-size: 21px;
        color: #1b2432;
        letter-spacing: 0;
        margin-bottom: 5px;
      }

  .components-CompanyDetails-CommercialRewards-styles___paper--MQNv6 .components-CompanyDetails-CommercialRewards-styles___commercialRewardsHeader--XN_Sh .components-CompanyDetails-CommercialRewards-styles___text--AK1QF .components-CompanyDetails-CommercialRewards-styles___description--CNC6T {
        font-size: 13px;
        color: #6d717a;
        letter-spacing: 0;
      }

  .components-CompanyDetails-CommercialRewards-styles___paper--MQNv6 .components-CompanyDetails-CommercialRewards-styles___container--OOqkd {
    margin: 32px 0 0 0;
  }

  .components-CompanyDetails-CommercialRewards-styles___paper--MQNv6 .components-CompanyDetails-CommercialRewards-styles___container--OOqkd .components-CompanyDetails-CommercialRewards-styles___row--qkc_1 {
      display: flex;
      flex-direction: row;
      justify-content: space-between;
    }

  .components-CompanyDetails-CommercialRewards-styles___paper--MQNv6 .components-CompanyDetails-CommercialRewards-styles___container--OOqkd .components-CompanyDetails-CommercialRewards-styles___row--qkc_1 .components-CompanyDetails-CommercialRewards-styles___text--AK1QF .components-CompanyDetails-CommercialRewards-styles___title--Qlbga {
          margin-bottom: 8px;
        }

  .components-CompanyDetails-CommercialRewards-styles___paper--MQNv6 .components-CompanyDetails-CommercialRewards-styles___container--OOqkd .components-CompanyDetails-CommercialRewards-styles___row--qkc_1 .components-CompanyDetails-CommercialRewards-styles___text--AK1QF .components-CompanyDetails-CommercialRewards-styles___title--Qlbga h2 {
            font-size: 15px;
            font-weight: 500;
            color: #1b2432;
          }

  .components-CompanyDetails-CommercialRewards-styles___paper--MQNv6 .components-CompanyDetails-CommercialRewards-styles___container--OOqkd .components-CompanyDetails-CommercialRewards-styles___row--qkc_1 .components-CompanyDetails-CommercialRewards-styles___text--AK1QF .components-CompanyDetails-CommercialRewards-styles___description--CNC6T p {
            font-size: 13px;
            color: #6d717a;
            margin: 0;
          }

  .components-CompanyDetails-CommercialRewards-styles___paper--MQNv6 .components-CompanyDetails-CommercialRewards-styles___container--OOqkd .components-CompanyDetails-CommercialRewards-styles___row--qkc_1 .components-CompanyDetails-CommercialRewards-styles___selectWrapper--gw73b {
        width: 306px;
      }

/* Chrome, Safari, Edge, Opera */

input::-webkit-outer-spin-button,
input::-webkit-inner-spin-button {
  -webkit-appearance: none;
  margin: 0;
}

/* Firefox */

input[type='number'] {
  -moz-appearance: textfield;
}
`, "",{"version":3,"sources":["webpack://./components/CompanyDetails/CommercialRewards/styles.pcss"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,gBAAgB;EAChB,gBAAgB;AAsDlB;;EApDE;IACE,aAAa;EAkBf;;EAhBE;MACE,iBAAiB;IAcnB;;EAZE;QACE,eAAe;QACf,cAAc;QACd,iBAAiB;QACjB,kBAAkB;MACpB;;EAEA;QACE,eAAe;QACf,cAAc;QACd,iBAAiB;MACnB;;EAIJ;IACE,kBAAkB;EA6BpB;;EA3BE;MACE,aAAa;MACb,mBAAmB;MACnB,8BAA8B;IAuBhC;;EApBI;UACE,kBAAkB;QAMpB;;EALE;YACE,eAAe;YACf,gBAAgB;YAChB,cAAc;UAChB;;EAGA;YACE,eAAe;YACf,cAAc;YACd,SAAS;UACX;;EAIJ;QACE,YAAY;MACd;;AAKN,gCAAgC;;AAChC;;EAEE,wBAAwB;EACxB,SAAS;AACX;;AAEA,YAAY;;AACZ;EACE,0BAA0B;AAC5B","sourcesContent":[".paper {\n  padding: 32px;\n  max-width: 736px;\n  margin: 0 0 30px;\n\n  .commercialRewardsHeader {\n    display: flex;\n\n    .text {\n      margin-left: 22px;\n\n      h2 {\n        font-size: 21px;\n        color: #1b2432;\n        letter-spacing: 0;\n        margin-bottom: 5px;\n      }\n\n      .description {\n        font-size: 13px;\n        color: #6d717a;\n        letter-spacing: 0;\n      }\n    }\n  }\n\n  .container {\n    margin: 32px 0 0 0;\n\n    .row {\n      display: flex;\n      flex-direction: row;\n      justify-content: space-between;\n\n      .text {\n        .title {\n          margin-bottom: 8px;\n          h2 {\n            font-size: 15px;\n            font-weight: 500;\n            color: #1b2432;\n          }\n        }\n        .description {\n          p {\n            font-size: 13px;\n            color: #6d717a;\n            margin: 0;\n          }\n        }\n      }\n\n      .selectWrapper {\n        width: 306px;\n      }\n    }\n  }\n}\n\n/* Chrome, Safari, Edge, Opera */\ninput::-webkit-outer-spin-button,\ninput::-webkit-inner-spin-button {\n  -webkit-appearance: none;\n  margin: 0;\n}\n\n/* Firefox */\ninput[type='number'] {\n  -moz-appearance: textfield;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"paper": `components-CompanyDetails-CommercialRewards-styles___paper--MQNv6`,
	"commercialRewardsHeader": `components-CompanyDetails-CommercialRewards-styles___commercialRewardsHeader--XN_Sh`,
	"text": `components-CompanyDetails-CommercialRewards-styles___text--AK1QF`,
	"description": `components-CompanyDetails-CommercialRewards-styles___description--CNC6T`,
	"container": `components-CompanyDetails-CommercialRewards-styles___container--OOqkd`,
	"row": `components-CompanyDetails-CommercialRewards-styles___row--qkc_1`,
	"title": `components-CompanyDetails-CommercialRewards-styles___title--Qlbga`,
	"selectWrapper": `components-CompanyDetails-CommercialRewards-styles___selectWrapper--gw73b`
};
module.exports = ___CSS_LOADER_EXPORT___;
